export const APP_MAIN_SCROLL_SELECTOR = '.app-shell-main';
export const APP_SCROLL_REGION_SELECTOR = '[data-app-scroll-region]';

const isScrollableOverflow = (overflowY: string): boolean =>
  overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';

const scrollElementToTop = (element: HTMLElement | null | undefined, behavior: ScrollBehavior): void => {
  if (!element) {
    return;
  }

  if (typeof element.scrollTo === 'function') {
    element.scrollTo({ top: 0, left: 0, behavior });
    return;
  }

  element.scrollTop = 0;
  element.scrollLeft = 0;
};

export const scrollAppToTop = (behavior: ScrollBehavior = 'auto'): void => {
  scrollElementToTop(window as unknown as HTMLElement, behavior);
  scrollElementToTop(document.documentElement, behavior);
  scrollElementToTop(document.body, behavior);

  document
    .querySelectorAll<HTMLElement>(`${APP_MAIN_SCROLL_SELECTOR}, ${APP_SCROLL_REGION_SELECTOR}`)
    .forEach((element) => {
      scrollElementToTop(element, behavior);
    });

  const shell = document.querySelector('.app-shell');
  if (!shell) {
    return;
  }

  for (const element of shell.querySelectorAll<HTMLElement>('*')) {
    if (element.scrollTop <= 0) {
      continue;
    }

    if (element.closest('[data-sidebar]')) {
      continue;
    }

    if (isScrollableOverflow(getComputedStyle(element).overflowY)) {
      scrollElementToTop(element, behavior);
    }
  }
};

export const scrollAppMainToTop = scrollAppToTop;
